export default {"src":"/_next/static/media/sport.3507e224.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};